module.exports = __webpack_public_path__ + "static/media/1-9.9e96a9b7.mp3";